import LexusArrow from '@assets/icons/lexusArrow.svg'
import { useBrand } from '@contexts/useBrand'

type Props = {
  children: string
  isSubmitting: boolean
  isSubmitSuccessful: boolean
}

const SubmitInput = ({
  children,
  isSubmitting,
  isSubmitSuccessful,
  ...rest
}: Props) => {
  const brand = useBrand()
  if (brand === 'lexus') {
    return (
      <button
        {...rest}
        type="submit"
        className={`group inline-flex items-center justify-center flex-none rounded-btn !leading-10 pl-4 uppercase !bg-secondary text-white outline-0 !hover:opacity-50 !active:opacity-50 !focus:opacity-50 !disabled:cursor-not-allowed !disabled:opacity-50 ${
          isSubmitting || isSubmitSuccessful
            ? '!secondary-hover !opacity-50 !cursor-not-allowed !pointer-events-none'
            : ''
        }`}
        // data-gt-name="componentevent"
        // data-gt-action="button-click-cta"
        // data-gt-label="submit"
      >
        {isSubmitting && <div className="loader">Loading...</div>}
        <span className="text-sm text-center font-semibold !leading-[44px]">
          {children}
        </span>
        <LexusArrow className={`ml-2 mr-4 group-hover:mx-3`} />
      </button>
    )
  }

  return (
    <button
      type="submit"
      className={`inline-flex items-center justify-center flex-none rounded-btn px-6 py-3 text-white !outline-0 bg-base hover:bg-base-hover active:bg-base-hover focus:bg-base-hover !disabled:cursor-not-allowed disabled:bg-base-hover ${
        isSubmitting || isSubmitSuccessful
          ? '!bg-base-hover !cursor-not-allowed !pointer-events-none'
          : ''
      }`}
      // data-gt-name="componentevent"
      // data-gt-action="button-click-cta"
      // data-gt-label="submit"
    >
      {isSubmitting && <div className="loader">Loading...</div>}
      {children}
    </button>
  )
}

export default SubmitInput
